import { Plus } from "lucide-react";
import {
  useGetRecordRepresentation,
  useRecordContext,
  useTranslate,
} from "ra-core";
import { useState } from "react";
import { Button } from "@/components/ui/button";

import type { Company, Contact, CrmEvent } from "../types";
import { getDefaultEventStart } from "./calendarUtils";
import { EventCreateDialog } from "./EventDialogs";

/** "Add event" button of a company or contact page, prefilled with that record. */
export const AddEvent = ({ target }: { target: "company" | "contact" }) => {
  const translate = useTranslate();
  const record = useRecordContext<Company | Contact>();
  const getContactRepresentation = useGetRecordRepresentation("contacts");
  const [open, setOpen] = useState(false);
  if (!record) return null;

  const defaults: Partial<CrmEvent> =
    target === "company"
      ? { company_id: record.id }
      : {
          contact_id: record.id,
          company_id: (record as Contact).company_id ?? undefined,
        };
  const name =
    target === "company"
      ? (record as Company).name
      : getContactRepresentation(record);

  return (
    <div className="my-2">
      <Button
        variant="outline"
        className="h-6 cursor-pointer"
        onClick={() => setOpen(true)}
        size="sm"
      >
        <Plus className="w-4 h-4" />
        {translate("resources.events.action.add")}
      </Button>
      <EventCreateDialog
        open={open}
        onClose={() => setOpen(false)}
        record={{ ...defaults, start_at: getDefaultEventStart(new Date()) }}
        title={translate("resources.events.dialog.create_for", { name })}
      />
    </div>
  );
};
